import React from "react";
import styled from "styled-components";

const Loader = ({ className = "" }) => {
  return <Spinner className={className} />;
};

const Spinner = styled.span`
  position: absolute;
  top: 20%;
  z-index: 10000;

  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #78b833;
  border-radius: 50%;

  width: 3.5em;
  height: 3.5em;

  animation: spin 1.2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Loader;
